module.exports = __webpack_public_path__ + "img/vue-mk-header.98fb6ce8.jpg";